"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _highchartsReactOfficial = _interopRequireDefault(require("highcharts-react-official"));

var _utils = require("./utils");

var _Labels = _interopRequireDefault(require("./Labels"));

var _Legend = _interopRequireDefault(require("./Legend"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RiskReturnChart(props) {
  var data = props.data,
      height = props.height,
      minX = props.minX,
      maxX = props.maxX,
      minY = props.minY,
      maxY = props.maxY,
      xLabels = props.xLabels,
      yLabels = props.yLabels,
      tooltipFormat = props.tooltipFormat;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "risk-return-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "risk-return-chart-container"
  }, /*#__PURE__*/_react.default.createElement(_highchartsReactOfficial.default, {
    containerProps: {
      className: 'highcharts-risk-return'
    },
    options: (0, _utils.getScatterChartOptions)(data, height, minX, maxX, minY, maxY, xLabels, yLabels, tooltipFormat)
  }), /*#__PURE__*/_react.default.createElement(_Labels.default, {
    xLabels: xLabels,
    yLabels: yLabels
  })), /*#__PURE__*/_react.default.createElement(_Legend.default, {
    data: data
  }));
}

RiskReturnChart.propTypes = {
  /** Data to be shown on chart */
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    data: _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.number)).isRequired
  })),

  /** Height of chart */
  height: _propTypes.default.number,

  /** The min value for x axis */
  minX: _propTypes.default.number,

  /** The max value for x axis */
  maxX: _propTypes.default.number,

  /** The min value for y axis */
  minY: _propTypes.default.number,

  /** The max value for y axis */
  maxY: _propTypes.default.number,

  /** The labels for x axis */
  xLabels: _propTypes.default.arrayOf(_propTypes.default.string),

  /** The labels for y axis */
  yLabels: _propTypes.default.arrayOf(_propTypes.default.string),

  /** Formatter for tooltip */
  tooltipFormat: _propTypes.default.func
};
RiskReturnChart.defaultProps = {
  data: [],
  height: 400,
  minX: 0,
  maxX: 10,
  minY: 0,
  maxY: 20,
  xLabels: [],
  yLabels: [],
  tooltipFormat: function tooltipFormat(name, x, y) {
    return "".concat(name, ": ").concat(x, "/").concat(y);
  }
};
var _default = RiskReturnChart;
exports.default = _default;